import { h } from 'preact'
import { Provider } from 'react-redux'
import store from 'app/core/state/store'

/**
 * Wraps a component in a redux store provider.
 * @param   {Component}     Component   -   The component to wrap.
 * @param   {any}           restProps   -   Props passed to web component from define().
 */
const withProvider = Component => restProps => (
    <Provider store={store}>
        <Component {...restProps} />
    </Provider>
);

export default withProvider
